export default {
  // Tabs / sections
  'aes.tab.info': 'Info',
  'aes.tab.documents': 'Documents',
  'aes.section.filing': 'Filing & Shipment',
  'aes.section.parties': 'Parties',
  'aes.section.commodity_items': 'Commodity Items',

  // Filing & shipment fields
  'aes.field.filer_ein': 'Filer ID (EIN)',
  'aes.field.filing_option': 'Filing Option',
  'aes.field.aei_filing_type': 'AEI Filing Type',
  'aes.field.shipment_file_number': 'Shipment File No.',
  'aes.field.shipment_number': 'Shipment No. (ITN)',
  'aes.field.mode_of_transport_code': 'Mode of Transport',
  'aes.field.op_type': 'Operation Type',
  'aes.field.ultimate_country': 'Ultimate Country',
  'aes.field.state_of_origin': 'State of Origin',
  'aes.field.carrier': 'Carrier',
  'aes.field.carrier_code': 'Carrier Code (SCAC/IATA)',
  'aes.field.vessel': 'Vessel / Conveyance',
  'aes.field.port_of_loading': 'Port of Loading',
  'aes.field.loading_date': 'Loading Date',
  'aes.field.port_of_discharge': 'Port of Discharge',
  'aes.field.discharge_date': 'Discharge Date',
  'aes.field.routed_export_indicator': 'Routed Export Transaction',
  'aes.field.related_company_indicator': 'Related Company',
  'aes.field.hazmat_indicator': 'Hazardous Material',
  'aes.field.inbond_type': 'In-bond Type',
  'aes.field.inbond_number': 'In-bond No.',
  'aes.field.foreign_trade_zone': 'Foreign Trade Zone',
  'aes.field.entry_number': 'Entry No.',
  'aes.field.master_bill_number': 'Master Bill No.',
  'aes.field.submit_by': 'Submit By',

  // Filing option labels
  'aes.option.filing.2': '2 - Predeparture (full)',
  'aes.option.filing.3': '3 - Advance Export Information (AEI)',
  'aes.option.filing.4': '4 - Postdeparture',
  'aes.option.aei.P': 'P - Partial predeparture',
  'aes.option.aei.F': 'F - Full postdeparture',
  'aes.option.op.OE': 'OE - Ocean Export',
  'aes.option.op.AE': 'AE - Air Export',
  'aes.option.op.DO': 'DO - Domestic',
  'aes.option.inbond.36': '36 - Warehouse withdrawal for IE',
  'aes.option.inbond.37': '37 - Warehouse withdrawal for T&E',
  'aes.option.inbond.67': '67 - FTZ withdrawal for IE',
  'aes.option.inbond.68': '68 - FTZ withdrawal for T&E',
  'aes.option.inbond.70': '70 - Not shipped in-bond',

  // Parties
  'aes.party.usppi': 'USPPI (US Principal Party in Interest)',
  'aes.party.forwarding_agent': 'Forwarding Agent',
  'aes.party.ultimate_consignee': 'Ultimate Consignee',
  'aes.party.intermediate_consignee': 'Intermediate Consignee',
  'aes.field.ultimate_consignee_type': 'Ultimate Consignee Type',
  'aes.option.consignee.D': 'D - Direct Consumer',
  'aes.option.consignee.G': 'G - Government Entity',
  'aes.option.consignee.O': 'O - Other/Unknown',
  'aes.option.consignee.R': 'R - Reseller',

  // Commodity item fields
  'aes.field.commodity.hts_number': 'Schedule B / HTS No.',
  'aes.field.commodity.description': 'Description',
  'aes.field.commodity.qty1': 'Quantity 1',
  'aes.field.commodity.qty1_unit': 'Unit 1',
  'aes.field.commodity.qty2': 'Quantity 2',
  'aes.field.commodity.qty2_unit': 'Unit 2',
  'aes.field.commodity.origin': 'Origin',
  'aes.field.commodity.value': 'Value (USD)',
  'aes.field.commodity.gross_weight': 'Gross Weight (KG)',
  'aes.field.commodity.export_code': 'Export Code',
  'aes.field.commodity.license_type': 'License Type',
  'aes.field.commodity.eccn': 'ECCN',
  'aes.field.commodity.license_number': 'License No.',
  'aes.option.origin.D': 'D - Domestic',
  'aes.option.origin.F': 'F - Foreign',
  'aes.commodity.add': 'Add Commodity Item',
  'aes.commodity.edit': 'Edit Commodity Item',
  'aes.commodity.empty': 'At least one commodity item is required.',

  // Status / list
  'aes.field.status': 'Status',
  'aes.list.ext_id': 'AES No.',
  'aes.list.shipment_number': 'Shipment No. (ITN)',
  'aes.list.op_type': 'Operation',
  'aes.list.carrier': 'Carrier',
  'aes.list.port_of_loading': 'POL',
  'aes.list.port_of_discharge': 'POD',
  'aes.list.create': 'Create',

  // Messages
  'aes.save.success': 'AES saved successfully',
  'aes.save.error': 'Failed to save AES',
  'aes.update.success': 'AES updated successfully',
  'aes.submit.success': 'AES submitted successfully',
  'aes.submit.error': 'Failed to submit AES',
  'aes.submit.save_first': 'Please save the AES first before submitting',
  'aes.delete.success': 'AES deleted',
  'aes.delete.confirm': 'Delete this AES filing?',
  'aes.parties.required': 'USPPI and Ultimate Consignee are required (at least two parties).',
};
